import MyDesignsDialog from './MyDesignsDialog';

export default MyDesignsDialog;
